import { DadosContainerDefault } from "../../components/Styles"
import AvaliacaoDisc from "../../components/AvaliacaoDisc"
import { useEffect } from "react"
import Permissoes from "../../middleware/Permissoes"

function QuestionarioDisc() {

  useEffect(() => {
    document.title = "Questionário Disc | Gesttor"
  }, [])

  return (
    <DadosContainerDefault>
       <Permissoes permissoes={['master', 'recrutamento_disc']}>
          <AvaliacaoDisc />
       </Permissoes>
    </DadosContainerDefault>
  )
}

export default QuestionarioDisc